import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';

import { MatIconModule } from '@angular/material/icon';
import { LocalStorageService } from '../../services/localstorage/local-storage.service';
import { FilterButtonComponent } from "../filter-button/filter-button.component";
import { TeamListFilter } from '../../models/teams/team-list-filter';
import { TeamListDto } from '../../models/teams/team-list-dto';
import { TeamListService } from '../../services/team-list/team-list.service';
import { TeamApiService } from '../../services/api/team-api.service';
import { FilterInputChipsComponent } from "../filter-input-chips/filter-input-chips.component";

@Component({
  selector: 'app-team-list-filter',
  imports: [MatFormField, MatLabel, ReactiveFormsModule, FormsModule, MatInput, MatIconModule, MatInputModule, FilterButtonComponent, FilterInputChipsComponent],
  templateUrl: './team-list-filter.component.html',
  styleUrl: './team-list-filter.component.scss',
  standalone: true
})
export class TeamListFilterComponent {
  filterValues!: TeamListFilter;

  private teams: TeamListDto[] = [];
  allTeamTypes: string[] = [];
  allProductionTechnicianAreas: string[] = [];
  allProductionLeaders: string[] = [];
  allStatuses: string[] = [];
  allOwnerTypes: string[] = [];
  searchTerm: string = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private teamListService: TeamListService, private teamApiService: TeamApiService, private localStorage: LocalStorageService) {
    this.filterValues = this.localStorage.getTeamFilter();

    this.teamListService.data$.subscribe(async teamList => {
      this.teams = teamList ? teamList : [];
      if (this.teams) {
        this.initializeFilters();
      }
    })
  }

  ngAfterViewInit() {
    this.initializeFilters();
  }

  async initializeFilters() {
    this.allProductionTechnicianAreas = [...new Set(this.teams.map(wo => wo.productionTechnicianAreaText).filter(v => v))].sort();
    this.allProductionLeaders = [...new Set(this.teams.map(wo => wo.baseInfo.productionLeaderText).filter(v => v))].sort();
    this.allOwnerTypes = [...new Set(this.teams.map(wo => wo.statusInfo.ownerTypeText).filter(v => v))].sort();
    this.allStatuses = [...new Set(this.teams.map(wo => wo.statusInfo.statusText).filter(v => v))].sort();
    this.searchTerm = this.filterValues.search.length === 1 ? this.filterValues.search[0].value : '';

    this.applyFilter();
  }

  applyFilter() {
    if (this.filterValues.search.length === 0) {
      this.searchTerm = '';
    }

    this.filterValues = { ...this.filterValues };
    this.teamListService.applyFilter(this.filterValues);
    this.localStorage.saveTeamFilter(this.filterValues);
  }

  compareWith(compare1: any, compare2: any): boolean {
    return compare1 && compare2 && compare1.id === compare2.id;
  }

  filterSelectableValuesByQuery() {
    const hasSearchTerm = (this.searchTerm ?? '').trim().length > 0;

    if (!hasSearchTerm) {
      this.filterValues.search = [];
      this.applyFilter();
      return;
    }

    this.searchTerm = this.searchTerm.trim();

    if (!this.filterValues.search || this.filterValues.search.length === 0) {
      this.filterValues.search = [{ value: this.searchTerm, activated: true }];
    } else {
      this.filterValues.search[0].value = this.searchTerm;
      this.filterValues.search[0].activated = true;
    }

    this.applyFilter();
  }
}
